import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const investorLoginUrl = 'https://adfs4.sts.altareturn.com/adfs/ls/?wa=wsignin1.0&wtrealm=urn%3aportal%3aracecapital&wctx=https%3a%2f%2fracecapital.altareturn.com%2f_layouts%2f15%2fAuthenticate.aspx%3fSource%3d%252F&wreply=https%3a%2f%2fracecapital.altareturn.com%2f_trust%2fdefault.aspx';
  const pitchUsUrl = 'https://airtable.com/appMNWbdHmSVm3l1M/shruyLbAMcJUdRUj6';
  return <nav className="w-full py-6 px-6 md:px-12 bg-white/80 backdrop-blur-md border-b border-gray-200/50 transition-colors fixed top-0 z-50" data-id="element-67" data-mp="9kb2hge2kvdv">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-68" data-mp="1pxi32bgacxt0">
          <div className="flex items-center" data-id="element-69" data-mp="1kzzs6fipk8id">
            <Logo data-id="element-70" data-mp="1kz86bwewxp5a" />
          </div>
          <div className="hidden md:flex items-center space-x-10" data-id="element-71" data-mp="9ohibgcpx9ov">
            <NavLink to="/how-we-invest" data-id="element-72" data-mp="9o7qdn844sgj">How We Invest</NavLink>
            <NavLink to="/how-we-help" data-id="element-73" data-mp="emj3q7xm9l3i">How We Help</NavLink>
            <NavLink to="/companies" data-id="element-74" data-mp="jmnk7xyiyftq">Portfolio</NavLink>
            <NavLink to="/team" data-id="element-75" data-mp="jn6sso2abrv3">Team</NavLink>
            <NavLink to="/blog" data-id="element-76" data-mp="olqj10nwvpt9">News</NavLink>
            <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors" data-id="element-77" data-mp="okfegymn6e13">
              Investor Login
            </a>
          </div>
          <div className="md:hidden flex items-center" data-id="element-78" data-mp="vdymqbhc0ls">
            <button className="text-[#070707]" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-79" data-mp="5mw33ocpojbi">
              {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-80" data-mp="34as44k904go1" /> : <MenuIcon className="h-6 w-6" data-id="element-81" data-mp="39ao8wlpiwc4n" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {mobileMenuOpen && <div className="md:hidden mt-6 pb-4" data-id="element-82" data-mp="2wcq84fzpfo9m">
            <div className="flex flex-col space-y-4" data-id="element-83" data-mp="2wbwxh3xmkem7">
              <MobileNavLink to="/how-we-invest" onClick={() => setMobileMenuOpen(false)} data-id="element-84" data-mp="3b1ckc8u1bzwm">
                How We Invest
              </MobileNavLink>
              <MobileNavLink to="/how-we-help" onClick={() => setMobileMenuOpen(false)} data-id="element-85" data-mp="2ibvy5sx0df8u">
                How We Help
              </MobileNavLink>
              <MobileNavLink to="/companies" onClick={() => setMobileMenuOpen(false)} data-id="element-86" data-mp="2sb4ng8gxi5ov">
                Portfolio
              </MobileNavLink>
              <MobileNavLink to="/team" onClick={() => setMobileMenuOpen(false)} data-id="element-87" data-mp="7k46s16cbm7p">
                Team
              </MobileNavLink>
              <MobileNavLink to="/blog" onClick={() => setMobileMenuOpen(false)} data-id="element-88" data-mp="2nm18z36rjub">
                News
              </MobileNavLink>
              <a href={investorLoginUrl} target="_blank" rel="noopener noreferrer" className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-89" data-mp="f56ode53yd6v">
                Investor Login
              </a>
            </div>
          </div>}
      </nav>;
};
const Logo = () => {
  return <Link to="/" className="flex items-center" data-id="element-90" data-mp="k3rmn80sumso">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9QqUfvRDGwG7W9qysjtvXP/RC-Logo_01-PositiveRGB.png" alt="Race Capital Logo" className="h-10" data-id="element-91" data-mp="k0vp3ksv604r" />
    </Link>;
};
const NavLink = ({
  to,
  children,
  className = ''
}) => <Link to={to} className={`text-[#070707] hover:text-red-600 font-medium text-sm transition-colors ${className}`} data-id="element-92" data-mp="1glwa37zxeiup">
    {children}
  </Link>;
const MobileNavLink = ({
  to,
  children,
  onClick
}) => <Link to={to} className="text-[#070707] hover:text-red-600 font-medium text-sm transition-colors block px-4 py-2" onClick={onClick} data-id="element-93" data-mp="3k22n34efg6q6">
    {children}
  </Link>;